import axiosInstance from './AxiosInstance';

export const addMerchantKyc = (getData) => {
  return axiosInstance.get("user-kyc-list/list", {
    params: getData,
  });
};


export const getMerchantKyc = (getData) => {
  return axiosInstance.get("user-kyc-list/list", {
    params: getData,
  });
};

export const getMerchantKycCount = (getData) => {
  return axiosInstance.get("user-kyc-list/details", {
    params: getData,
  });
};


export const updateMerchantKyc = async(id, data) => {
  const formData = new FormData();
  formData.append("kycID", data.kycID);
  formData.append("status", data.status);
  if (data.type === "File Upload") {
    formData.append("value", data.value); // assuming value is File object
  } else {
    formData.append("value", data.value);
  }
  return await axiosInstance.put(`user-kyc-list/update/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchMerchantKycById = async (id) => {
    const response = await axiosInstance.get(`user-kyc-list/list/${id}`);
    return response.data;
};
